export default {
  hello: 'Hallo, {name}!',
  agenciesNoOptions: 'De gebruiker behoort niet tot een agentschap',
  selectAgency: 'Selecteer jouw agentschap',
  agencies: 'Agentschappen',
  dashboard: 'Dashboard'
};
